import { useTranslation } from "react-i18next"
import { observer } from "mobx-react-lite"
import { IUser } from "../../interfaces"
import { Text } from "../."
import { StyledButton, StyledButtonProps } from "../buttons"
import { UserIcon } from "../profile"

interface IQuestionnaireUserBadgeProps extends Omit<StyledButtonProps, "style"> {
	user?: IUser
}

export const QuestionnaireUserBadge = observer(({ user, disabled, onClick, ...props }: IQuestionnaireUserBadgeProps) => {
	const { t } = useTranslation()

	const splitUserName = () => {
		return user?.displayName.split(" ")[0] ?? t("questionnaire.anonymously")
	}

	return (
		<StyledButton onClick={onClick} disabled={disabled} {...props} style={`${disabled ? "bg-[#202020]" : ""}`}>
			<div className={`flex ${disabled ? "border-[#393939]" : "border-white"} h-[130px] w-[130px] items-center justify-center border`}>
				<UserIcon displayName={user?.displayName || ""} url={user?.photoURL ?? ""} />
				<Text style={`mt-3  ${disabled ? "text-[#a0a0a0]" : ""}`}>{splitUserName()}</Text>
			</div>
		</StyledButton>
	)
})
